import { gql } from '@apollo/client';

export const CREATE_CALLBACK = gql`
    mutation createCallback($input: CreateCallbackInput!) {
        result: createCallback(input: $input) {
            id
            type
            url
        }
    }
`;


export const PATCH_CALLBACK = gql`
    mutation patchCallback($input: PatchCallbackInput!) {
        result: patchCallback(input: $input) {
            id
            type
            url
        }
    }
`;


export const DELETE_CALLBACK = gql`
    mutation deleteCallback($input: DeleteCallbackInput!) {
        result: deleteCallback(input: $input) {
            affectedRows
        }
    }
`;